import { createAsyncThunk } from "@reduxjs/toolkit";
import { customerPortal, toast } from "@vilocnv/allsetra-core";
import { getObjectDataForMap } from "domain/objects/api/get-object-data-for-map";

type ObjectForMapRequestDto = customerPortal.objects.ObjectForMapRequestDto;

const getObjectDataForMapAction = createAsyncThunk(
  "objects/v2/getObjectDataForMapAction",
  async (payload: ObjectForMapRequestDto) => {
    try {
      const data = await getObjectDataForMap(payload);
      const { objectId } = payload;

      return { ...data, uniqueId: objectId };
    } catch (e: any) {
      const { objectId } = payload;
      toast.error(e.message, { toastId: `object-map-${objectId}` });
      throw new Error(e);
    }
  }
);

export default getObjectDataForMapAction;
